import React from 'react';
import PropTypes from 'prop-types';

import styles from './styles.module.css';

const Designer = ({
  title,
  subtitle,
  icon,
  className,
  id,
  descriptionClassName,
  iconClassName,
  endYear,
  goToDesignerDetail,
}) => {

  const elemId = title.replace(/ /g, '_').toLowerCase();

  return (
    <div
      id={elemId}
      data-end-year={endYear}
      className={`${className} ${styles.designerItem}`}>
      <div
        className={`${iconClassName} ${styles.designerItemIcon}`}
        onClick={ () => { goToDesignerDetail(id) }}
        title={`${title} - ${subtitle}`}
      >
        <img src={icon} alt={title} />
      </div>
      <div className={`${descriptionClassName} ${styles.designerItemWrapperTitle}`}>
        {title && <div className={styles.designerItemTitle} dangerouslySetInnerHTML={{ __html: title }}/>}
        {subtitle && <div className={styles.designerItemSubTitle} dangerouslySetInnerHTML={{ __html: subtitle }}/>}
      </div>
    </div>
  );
}

Designer.propTypes = {
  className: PropTypes.string,
  endYear: PropTypes.number,
  iconClassName: PropTypes.string,
  descriptionClassName: PropTypes.string,
  icon: PropTypes.string,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  id: PropTypes.string,
  type: PropTypes.string,
  goToDesignerDetail: PropTypes.func,
};

export default Designer;